import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import 'typeface-roboto';

// base theme
const defaultTheme = createTheme({
  palette: {
    primary: {
      main: '#FABD01',
    },
    secondary: {
      main: '#4199AC',
      light: '#9bced9',
      dark: '#1C768A',
      contrastText: '#FFFFFF',
    },
    text: {
      primary: '#333333',
      secondary: '#808080',
    },
    error: {
      main: '#F08144',
      light: '#FFB2A0',
      dark: '#FE9E67',
      contrastText: '#EFA176',
    },
    warning: {
      main: '#FCD764',
      light: '#FFDE77',
      dark: '#F8D772',
      contrastText: '#FFE699',
    },
    success: {
      main: '#78934B',
      light: '#9BBA67',
      dark: '#9BAE7B',
    },
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: 3,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: 0.2,
  },
  typography: {
    fontFamily: 'Roboto',
    button: {
      textTransform: 'none',
      fontFamily: 'Roboto',
    },
    h1: {
      fontFamily: 'Roboto',
    },
    h2: {
      fontFamily: 'Roboto',
    },
    h3: {
      fontFamily: 'Roboto',
    },
    h4: {
      fontFamily: 'Roboto',
    },
    h5: {
      fontFamily: 'Roboto',
    },
    h6: {
      fontFamily: 'Roboto',
    },
    allVariants: {
      fontFamily: 'Roboto',
      wordBreak: 'break-word',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        disableElevation: true,
      },
      defaultProps: {
        color: 'secondary',
        variant: 'contained',
      },
    },
    MuiSlider: {
      defaultProps: {
        color: 'secondary',
      },
    },
    MuiIconButton: {
      defaultProps: {
        color: 'secondary',
      },
    },
    MuiTextField: {
      defaultProps: {
        color: 'secondary',
      },
    },
    MuiLink: {
      defaultProps: {
        color: 'secondary',
      },
    },
  },
});

export const theme = responsiveFontSizes(defaultTheme);

export default theme;
